// extracted by mini-css-extract-plugin
export default {"main":"LoadingPage_main__R4set"};